jQuery(document).ready(function($) {
	if ($('body').hasClass('home')) {
		var waypoint = new Waypoint({
			element: $('.flexible-content:nth-child(1)'),
			handler: function(direction) {
				if (direction==='down') {
					$('header.header').removeClass('transparent');
					$('header.header').find('a').addClass('dark');
				} else {
					$('header.header').addClass('transparent');
					$('header.header').find('a').removeClass('dark');
				}
			},
			offset: -100
		});
	}
	$(document)
	.on('click', '.screen-reader-link.skip-section', function(e) {
		e.preventDefault();
		var nextSection = $(this).closest('.flexible-content').next();
		if (nextSection.length>0) {
			if (nextSection.find('a').length>0) {
				nextSection.find('a').first().trigger('focus');
				$('html, body').animate({
					scrollTop: nextSection.offset().top - $('header.header').height()*1.5
				}, 250);
				return;
			}
		}
		$(this).closest('.flexible-content').find('a').last().focus();
	});
});